/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_InvalidationInputs */

const en_password_invalidation = /** @type {(inputs: Password_InvalidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password must be at least 12 characters and contain at least 2 letters and 2 numbers`)
};

const nl_password_invalidation = /** @type {(inputs: Password_InvalidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachtwoord moet minimaal 12 tekens lang zijn en minimaal 2 letters en 2 cijfers bevatten`)
};

/**
* | output |
* | --- |
* | "Password must be at least 12 characters and contain at least 2 letters and 2 numbers" |
*
* @param {Password_InvalidationInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const password_invalidation = /** @type {((inputs?: Password_InvalidationInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_InvalidationInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_password_invalidation(inputs)
	return en_password_invalidation(inputs)
});